import { z } from "zod";

export const ticketSchema = z.object({
  first_name: z
    .string()
    .min(3, "نام نمی‌تواند کمتر از ۳ حرف باشد.")
    .max(50)
    .regex(/^[\u0600-\u06FF\s\u200c]+$/, "فقط حروف فارسی مجاز است."),
  last_name: z
    .string()
    .min(3, "نام خانوادگی نمی‌تواند کمتر از ۳ حرف باشد.")
    .max(50)
    .regex(/^[\u0600-\u06FF\s\u200c]+$/, "فقط حروف فارسی مجاز است."),
  mobile: z
    .string()
    .min(1, "شماره تلفن همراه را وارد کنید .")
    .regex(/^09\d{9}$/, "شماره تلفن همراه باید با 09 شروع شود و 11 رقم باشد."),
  email: z.union([z.literal(""), z.email("ایمیل معتبر نیست.")]),
  subject: z.string().min(1, "موضوع را وارد کنید.").max(200),
  body: z.string().min(1, "توضیحات را وارد کنید .").max(2000),
});

export type TicketFormValues = z.infer<typeof ticketSchema>;
